import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NUMERO DOCUMENTO' htmlFor='input-numeroDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='numeroDocumento'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-numeroDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
